// Import
import firebase from '../config/FirebaseConfig'
import ForeplayAPI from '@/api/foreplayServer'
import AxiosConfig from '../foreplayServer/serverAxiosConfig'

// Setup
const db = firebase.firestore()

// Get All Advertisements By User
export const getAllByUser = async () => {
  const user = firebase.auth().currentUser
  if (!user) return []
  const userAuthToken = await user.getIdToken()

  const { data: response } = await AxiosConfig.get('/fs/ads/user', {
    headers: {
      Authorization: `Bearer ${userAuthToken}`
    }
  })

  return response.data
}

// Get An Advertisement By ad_id
export const getByID = async (id) => {
  // const adId = Number(id)
  // // If its not a numeric id, check for the ad via alphanumeric id
  // if (isNaN(adId)) {
  //   const retryAds = await db.collection('ads').where('id', '==', id).get()
  //   return retryAds.docs[0].data()
  // }
  // const ads = await db.collection('ads').where('ad_id', '==', adId).get()
  // return ads.docs[0].data()
  const user = firebase.auth().currentUser
  if (!user) return null
  const userAuthToken = await user.getIdToken()


  const { data: response } = await AxiosConfig.get(`/fs/ads/${id}`, {
    headers: {
      Authorization: `Bearer ${userAuthToken}`
    }
  })

  return response.data
}

export const getUniqueAdById = async (id) => {
  const ad = await db.collection('unique-ads').doc(id).get()
  return {
    ...ad.data(),
    id: ad.id
  }
}

// Get and Advertisment by its FirebaseId
export const get = async (id) => {
  // const ad = await db.collection('ads').doc(id).get()
  // return {
  //   ...ad.data(),
  //   id
  // }

  const user = firebase.auth().currentUser
  if (!user) return null
  const userAuthToken = await user.getIdToken()


  const { data: response } = await AxiosConfig.get(`/fs/ads/id/${id}`, {
    headers: {
      Authorization: `Bearer ${userAuthToken}`
    }
  })

  return response.data
}

const create = async (payload) => {
  // return db.collection('ads').add(payload)
  const user = firebase.auth().currentUser
  if (!user) return null
  const userAuthToken = await user.getIdToken()


  const { data: response } = await AxiosConfig.post('/fs/ads/create', payload, {
    headers: {
      Authorization: `Bearer ${userAuthToken}`
    }
  })

  return response.data
}

// Update Ad
const update = async (adID, payload) => {
  // return await db
  //   .collection('ads')
  //   .doc(adID)
  //   .update(payload)

  const user = firebase.auth().currentUser
  if (!user) return null
  const userAuthToken = await user.getIdToken()


  const { data: response } = await AxiosConfig.patch(`/fs/ads/${adID}`, payload, {
    headers: {
      Authorization: `Bearer ${userAuthToken}`
    }
  })

  return response.data
}

// Gpt prompt redirect
// TODO @sam; not used rn
const createGptPrompt = async (payload) => {
  return await db.collection('extension-gpt-promps').add(payload)
}

const checkIfSaved = async (adId) => {
  const user = firebase.auth().currentUser
  if (!user) return null
  const userAuthToken = await user.getIdToken()


  const { data: response } = await AxiosConfig.get(`/fs/ads/${adId}`, {
    headers: {
      Authorization: `Bearer ${userAuthToken}`
    }
  })

  return { isSaved: !!response?.data, id: response?.data?.id, data: response?.data }
}

const deleteAll = async (docIds) => {
  const user = firebase.auth().currentUser
  if (!user) return null
  const userAuthToken = await user.getIdToken()


  const { data: response } = await AxiosConfig.delete('/fs/ads/bulk', {
    data: { docIds },
    headers: {
      Authorization: `Bearer ${userAuthToken}`
    }
  })

  return response.data
}

// [{id: '123', payload: {FIELD_NAME: 'value'}}]
const updateAll = async (adsToUpdate) => {
  const user = firebase.auth().currentUser
  if (!user) return null
  const userAuthToken = await user.getIdToken()


  const { data: response } = await AxiosConfig.patch('/fs/ads/bulk', adsToUpdate, {
    headers: {
      Authorization: `Bearer ${userAuthToken}`
    }
  })

  return response.data
}

const getByUserBrand = async (brandId, lastDocId) => {
  const user = firebase.auth().currentUser
  if (!user) return null
  const userAuthToken = await user.getIdToken()


  const { data: response } = await AxiosConfig.get(`/fs/ads/user-brand/${brandId}`, {
    params: {
      lastDocId
    },
    headers: {
      Authorization: `Bearer ${userAuthToken}`
    }
  })

  return response.data
}

const getAllByIds = async (docIds) => {
  if (!docIds || docIds.length === 0) return { ads: [] }
  const user = firebase.auth().currentUser
  if (!user) return null
  const userAuthToken = await user.getIdToken()

  const { data: response } = await AxiosConfig.post(
    '/fs/ads/bulk/fetch',
    { docIds },
    {
      headers: {
        Authorization: `Bearer ${userAuthToken}`
      }
    }
  )

  return response.data
}
export default {
  getByID,
  getUniqueAdById,
  get,
  getAllByUser,
  create,
  update,
  deleteAll,
  updateAll,
  getAllByIds,
  getByUserBrand,
  checkIfSaved,
  createGptPrompt
}
